'use strict'
import { isEqual } from 'lodash'

const STATUS_DESCRIPTION = {
  P: 'Pending',
  A: 'Approved',
  D: 'Denied',
  N: 'Approved (Automated)',
  F: 'Future Change (Pending)'
}

function renderStatusDescription (status) {
  if (status === 'P') {
    return STATUS_DESCRIPTION.P
  } else if (status === 'A') {
    return STATUS_DESCRIPTION.A
  } else if (status === 'D') {
    return STATUS_DESCRIPTION.D
  } else if (status === 'N') {
    return STATUS_DESCRIPTION.N
  } else if (status === 'F') {
    return STATUS_DESCRIPTION.F
  } else {
    return ''
  }
}
function customizer (objValue, otherValue) {
  if (!objValue && !otherValue) {
    return true
  } else {
    return isEqual(objValue, otherValue)
  }
}

export default {
  renderStatusDescription: renderStatusDescription,
  customizer: customizer
}



// WEBPACK FOOTER //
// ./src/js/directory/ChangeRequestHelper.js